export class Responsavel {
    nome: string;
    cargo: string;
  }
  